import { USER_KEY } from '../constants'
import { EmployeeType } from '../models';

export default (): EmployeeType => {
  const { type } = JSON.parse(localStorage.getItem(USER_KEY) || '{}')
  return type;
}
